var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMobile
    ? _c(
        "v-bottom-nav",
        { attrs: { value: true, fixed: "", color: "primary" } },
        [
          _vm.showSchedulerButton
            ? _c(
                "v-btn",
                {
                  attrs: { value: "schedule" },
                  on: { click: _vm.goToScheduler }
                },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Scheduler")
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("mdi-calendar")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSLButton
            ? _c(
                "v-btn",
                { attrs: { value: "home" }, on: { click: _vm.goToHome } },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Service Logs")
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("mdi-pencil")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSLButton
            ? _c(
                "v-btn",
                { attrs: { value: "search" }, on: { click: _vm.goToSearch } },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Search Logs")
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("search")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d65d011", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d65d011","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom-nav.vue
// module id = null
// module chunks = 